(function ($, Drupal) {
  Drupal.behaviors.videos = {
    attach: function (context, settings) {

      var videoDivs = context.querySelectorAll('.colorbox-media-video');
      if (videoDivs && videoDivs.length > 0) {
        videoDivs.forEach(function (element, index) {
          
          if (index == 0) {
            var clone = $(element)[0].cloneNode();
            $(element).closest('.node__content').find('.video-featured__text').append(clone);
            var videoTeaserCTA = $(element).closest('.node__content').find('.cta-video');
            $(clone).append(videoTeaserCTA);
          } else {
            var clone = $(element)[0].cloneNode();
            $(element).closest('.node__content').find('.video-teaser__text').append(clone);
            var videoTeaserCTA = $(element).closest('.node__content').find('.cta-video');
            $(clone).append(videoTeaserCTA);
          }

        });
      }

    }
  };
})(jQuery, Drupal);
